import { render, staticRenderFns } from "./OrderListTable.vue?vue&type=template&id=0df13236&scoped=true"
import script from "./OrderListTable.vue?vue&type=script&lang=js"
export * from "./OrderListTable.vue?vue&type=script&lang=js"
import style0 from "./OrderListTable.vue?vue&type=style&index=0&id=0df13236&prod&scoped=true&lang=css"
import style1 from "./OrderListTable.vue?vue&type=style&index=1&id=0df13236&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df13236",
  null
  
)

export default component.exports